import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { QueryClient } from '@tanstack/react-query'
import { ConvexQueryClient } from '@convex-dev/react-query'
import { ConvexReactClient } from 'convex/react'
import { initPostHog } from './lib/posthog'
import { initSentry } from './lib/sentry'

// Initialize monitoring only in the browser
if (typeof window !== 'undefined') {
  initSentry()
  initPostHog()
}

const CONVEX_URL = import.meta.env.VITE_CONVEX_URL

console.log('[Convex] Environment URL:', CONVEX_URL)
console.log('[Convex] import.meta.env:', import.meta.env)

if (!CONVEX_URL) {
  console.error('Missing VITE_CONVEX_URL environment variable')
  throw new Error('Missing VITE_CONVEX_URL environment variable')
}

const convexClient = new ConvexReactClient(CONVEX_URL!)
const convexQueryClient = new ConvexQueryClient(CONVEX_URL!)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryKeyHashFn: convexQueryClient.hashFn(),
      queryFn: convexQueryClient.queryFn(),
    },
  },
})

convexQueryClient.connect(queryClient)

export function getRouter() {
  const router = createRouter({
    routeTree,
    defaultPreload: 'intent',
    scrollRestoration: true,
    context: {
      queryClient,
      convexClient,
      convexQueryClient,
    },
  })

  return router
}

export { queryClient, convexClient, convexQueryClient }

// Register the router context for TypeScript
declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
